module.exports = __webpack_public_path__ + "img/cortanaicon.f55003b8.png";